import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Box, Stack, Typography } from "@mui/material";
import InfoIcon from "./InfoIcon";

type DurationInfoProps = {
  durationInMinutes: number;
};

export default function DurationInfo({
  durationInMinutes,
}: DurationInfoProps) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start">
      <InfoIcon>
        <AccessTimeIcon sx={{ fontSize: 18 }} />
      </InfoIcon>
      <Box>
        <Typography
          sx={{
            color: "#a8afbc",
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.2,
            textTransform: "uppercase",
          }}
        >
          Duration
        </Typography>
        <Typography
          sx={{
            color: "#5f6b7a",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.25,
          }}
        >
          {formatDuration(durationInMinutes)}
        </Typography>
      </Box>
    </Stack>
  );
}

function formatDuration(durationInMinutes: number) {
  const hours = durationInMinutes / 60;
  const formattedHours = Number.isInteger(hours)
    ? hours.toString()
    : Number(hours.toFixed(1)).toString();

  return `${formattedHours} ${hours === 1 ? "hour" : "hours"}`;
}
